export default __webpack_public_path__ + "static/media/DASHPORT_03.f9efa141.png";